import { render } from "./PaymentHelp.vue?vue&type=template&id=45c5ee6c"
import script from "./PaymentHelp.vue?vue&type=script&lang=js"
export * from "./PaymentHelp.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__